import { Plus, X } from "lucide-react"
import { useState } from "react"

import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

interface MultiplePathsInputProps {
  label?: string
  description?: string
  defaultPaths?: string[]
  name: string
  placeholder?: string
  position?: "top" | "bottom"
}

export default function MultiplePathsInput({
  label = "Source Paths",
  description,
  defaultPaths = [],
  name,
  placeholder = "/var/www/myapp",
  position = "top",
}: MultiplePathsInputProps) {
  const [paths, setPaths] = useState<string[]>(
    defaultPaths.length > 0 ? defaultPaths : [""],
  )

  function addPath() {
    setPaths([...paths, ""])
  }

  function removePath(index: number) {
    if (paths.length === 1) return
    setPaths(paths.filter((_, i) => i !== index))
  }

  function updatePath(index: number, value: string) {
    const newPaths = [...paths]
    newPaths[index] = value
    setPaths(newPaths)
  }

  return (
    <div className="grid gap-2">
      {position === "top" ? (
        <div className="flex items-center justify-between">
          <Label>{label}</Label>
          <Button type="button" variant="outline" size="sm" onClick={addPath}>
            <Plus className="mr-1 h-3 w-3" />
            Add Path
          </Button>
        </div>
      ) : (
        <div className="flex items-center justify-start">
          <Label>{label}</Label>
        </div>
      )}

      {description && (
        <p className="text-muted-foreground text-xs">{description}</p>
      )}

      <div className="space-y-2">
        {paths.map((path, index) => (
          <div key={index} className="flex gap-2">
            <Input
              type="text"
              name={`${name}[]`}
              defaultValue={path}
              placeholder={placeholder}
              className="flex-1"
            />
            {paths.length > 1 && (
              <Button
                type="button"
                variant="ghost"
                size="icon"
                onClick={() => removePath(index)}
              >
                <X className="h-4 w-4" />
              </Button>
            )}
          </div>
        ))}
      </div>

      {position === "bottom" && (
        <div className="flex items-center justify-end">
          <Button type="button" variant="outline" size="sm" onClick={addPath}>
            <Plus className="mr-1 h-3 w-3" />
            Add Path
          </Button>
        </div>
      )}
    </div>
  )
}
